import { DragDropModule } from '@angular/cdk/drag-drop';
import {Component, Inject, ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import {fuseAnimations} from '@fuse/animations';
import {ConfirmDialogData} from './confirm-dialog.types';

import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { BypassSecurityTrustHtmlPipe } from '../../pipes/bypass-security-trust-html.pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [DragDropModule, MatIconButton, MatIcon, MatDialogActions, MatButton, BypassSecurityTrustHtmlPipe, TranslocoPipe],
})
export class ConfirmDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    ) {
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

    confirm(): void {
        this.dialogRef.close(true);
    }
}
